import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@chakra-ui/react';
import { PiArrowsMergeBold } from 'react-icons/pi';
type MergeViewButtonProps = {
  onClick: () => void;
};
const MergeViewButton = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PiArrowsMergeBold />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <IconButton aria-label="Merge view" as="div" marginTop="1px" padding={3} size="md" title="Merge one view into another" variant="outline" onClick={onClick}>{t1}</IconButton>;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default MergeViewButton;